import { Modal, Typography, VStack } from '@vivaahealth/design-system';
import { useTranslation } from 'react-i18next';

interface VisitInstructionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  patientDirections: string;
  patientInstructions: string;
}

const VisitInstructionsModal = (props: VisitInstructionsModalProps) => {
  const { t } = useTranslation('digitalCheckIn');
  const { isOpen, patientDirections, patientInstructions, onClose } = props;

  return (
    <Modal
      open={isOpen}
      size="large"
      title={t('visitType', { type: t('instructions').toLowerCase() })}
      isFullScreenOnMobile
      onClose={() => onClose()}
    >
      <VStack gap={32}>
        {patientDirections.length > 0 && (
          <VStack gap={16}>
            <Typography
              variant="title-large"
              bold={true}
              children={t('directionsHeader')}
            />
            {patientDirections}
          </VStack>
        )}
        {patientInstructions.length > 0 && (
          <VStack gap={16}>
            <Typography
              variant="title-large"
              bold={true}
              children={t('instructionsHeader')}
            />
            {patientInstructions}
          </VStack>
        )}
      </VStack>
    </Modal>
  );
};

export default VisitInstructionsModal;
